import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { VehiclesService } from "../../vehicles/vehicles.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-add-edit-tyre",
  templateUrl: "./add-edit-tyre.component.html",
  styleUrls: ["./add-edit-tyre.component.sass"],
})
export class AddEditTyreComponent implements OnChanges {
  @Input() tyreData: any = null; // edit mode if not null
  @Input() showModal = false;
  @Output() refreshTyres = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  tyreForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private vehiclesService: VehiclesService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.tyreForm = this.fb.group({
      tyreType: ["", Validators.required],
    });
  }

  ngOnChanges() {
    if (this.tyreData) {
      // In edit mode, populate tyreType only
      this.tyreForm.patchValue({
        tyreType: this.tyreData.tyreType,
      });
    } else {
      this.tyreForm.reset();
    }
  }

  onSubmit() {
    if (!this.tyreForm.valid) {
      this.toastr.error("Please enter tyre type");
      return;
    }

    this.spinner.show();

    if (this.tyreData && this.tyreData._id) {
      // Update API call
      const id = this.tyreData._id;
      const payload = {
        tyreType: this.tyreForm.value.tyreType,
      };
      console.log("reqData", payload);
      this.vehiclesService.ediTyres(id, payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.statusCode === 200) {
            this.toastr.success(res.message);
            this.refreshTyres.emit();
            this.close();
          } else {
            this.toastr.error(res.message);
          }
        },
        error: (e) => {
          this.spinner.hide();
          this.toastr.error(e.message);
        },
      });
    } else {
      // Add API call — only send tyreType
      const payload = {
        tyreType: this.tyreForm.value.tyreType,
      };

      this.vehiclesService.addTyres(payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.statusCode === 200) {
            this.toastr.success(res.message);
            this.refreshTyres.emit();
            this.close();
          } else {
            this.toastr.error(res.message);
          }
        },
        error: (e) => {
          this.spinner.hide();
          this.toastr.error(e.message);
        },
      });
    }
  }

  close() {
    this.closeModal.emit();
  }
}
